export default __webpack_public_path__ + "static/media/georgia-logo.06971810.svg";